import React, { useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Config from "config";
import { get } from "helpers/api_helper";
import DeleteButton from "components/Common/DeleteButtonList";

function TableComponent({
  title,
  data,
  header,
  itemsPerPage,

  onClick,
}) {
  const [currentPage, setCurrentPage] = useState(0);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleClick = (documentId) => {
    onClick(documentId); // Récupère les détails du document en fonction de son ID
  };

  const offset = currentPage * itemsPerPage;
  const paginatedData = data.slice(offset, offset + itemsPerPage);
  const [modal, setModal] = useState(false);
  return (
    <>
      <div className="table-responsive" style={{ fontFamily: "sans-serif" }}>
        <table className="table">
          <thead>
            <tr>
              {title?.can_edit == false &&
              title?.can_show == false &&
              title?.can_destroy == false ? (
                <th></th>
              ) : (
                <th style={{ cursor: "default" }} key="Action" className="text">
                  Action
                </th>
              )}
              {header.map((column, index) => (
                <th key={index} style={{ whiteSpace: "nowrap" }}>
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              <>
                {paginatedData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>
                      <ul className="list-unstyled hstack gap-1 mb-0">
                        {title?.can_show ? (
                          <li
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="View"
                          >
                            <Link
                              className="btn btn-sm btn-soft-primary"
                              id={`viewtooltip-${rowIndex}`}
                              to={`${backUrl}/investisseurs/${row.id}`}
                            >
                              <i className="mdi mdi-eye-outline"></i>
                            </Link>
                          </li>
                        ) : null}
                        {title?.can_edit ? (
                          <li title="Editer">
                            <Link
                              className="btn btn-sm btn-soft-info"
                              id={`edittooltip-${rowIndex}`}
                              // to={`${backUrl}/investisseurs/${row.id}/edit`}
                              onClick={() => {
                                handleClick(row.id);
                              }}
                            >
                              <i className="mdi mdi-pencil-outline"></i>
                            </Link>
                          </li>
                        ) : null}
                        {title?.can_destroy ? (
                          <li title="Supprimer">
                            <DeleteButton
                              url={`https://www.fluxod.com/${api}/contact_documents/${row.id}`}
                            />
                          </li>
                        ) : null}
                      </ul>
                    </td>
                    <td>{row.categories_document_id}</td>
                    <td>{row.types_document_id}</td>
                    <td>{row.nom}</td>
                    <td>
                      {row?.fichier != null ? (
                        <a href={row?.fichier} download>
                          <i
                            style={{
                              fontSize: "25px",
                              paddingLeft: "8px",
                              textalign: "center",
                              verticalalign: "middle",
                            }}
                            className="bx bx-download"
                          ></i>
                        </a>
                      ) : null}
                    </td>
                    <td>{row.commentaires}</td>
                    <td>{row.cree_le}</td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan={header.length} style={{ textAlign: "center" }}>
                  Aucune donnée à afficher
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <ReactPaginate
          previousLabel={"<<"}
          breakLabel={"..."}
          nextLabel={">>"}
          pageCount={Math.ceil(data.length / itemsPerPage)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageChange}
          containerClassName={"pagination justify-content-center"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    </>
  );
}

export default TableComponent;
